export default [{
  header: 'Configuración',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: '/configuracion/panel',
      name: 'Panel',
      icon: 'GridIcon',
      slug: 'panel',
      permiso: 'WB000'
    }
  ]
}];
